import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { tap } from "rxjs/operators";
import { IApiBaseActions } from "../shared/interfaces/api-base-actions";
import { ApiBaseResponse } from "../shared/interfaces/api-base-response";
import { ResponseMessage } from "../shared/interfaces/response-message";

@Injectable({
  providedIn: "root",
})
export class ApiHandlerService implements IApiBaseActions {
  constructor(private httpClient: HttpClient) {}

  Get(url: string) {
    return this.httpClient.get<ApiBaseResponse>(url).pipe(tap((x) => this.HandleResponse(x)));
  }
  
  GetTenantData(url: string) {
    return this.httpClient.get<ApiBaseResponse>(url,{withCredentials:true}).pipe(tap((x) => this.HandleResponse(x)));
  }

  GetAll(url: string) {
    return this.httpClient.get<ApiBaseResponse>(url).pipe(tap((x) => this.HandleResponse(x)));
  }

  Post(url: string, data: any) {
    return this.httpClient.post<ApiBaseResponse>(url, data).pipe(tap((x) => this.HandleResponse(x)));
  }

  Delete(url: string) {
    return this.httpClient.delete<ApiBaseResponse>(url).pipe(tap((x) => this.HandleResponse(x)));
  }
  Put(url: string, data: any) {
    return this.httpClient.put<ApiBaseResponse>(url, data).pipe(tap((x) => this.HandleResponse(x)));
  }

  HandleResponse(response: any) {
    if (response.Status === 500) {
      alert(ResponseMessage.serverError);
    }
  }
}
